import React, { useMemo } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import * as Icons from './SidebarLogos';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';
const DefaultIcon = Icons.HomeLogo;

const menuItems = [
  { path: '/dashboard', icon: 'HomeLogo', label: 'Home' },
  { path: '/dashboard/contact', icon: 'ContactsLogo', label: 'Contacts Overview' },
  { path: '/dashboard/campaign/campaign-create', icon: 'SMSLogo', label: 'SMS Campaign Builder' },
  { path: '/dashboard/campaign/overview', icon: 'SMSInsightsLogo', label: 'SMS Campaign Overview' },
  { path: '/dashboard/campaign-analytics', icon: 'GraphLogo', label: 'SMS Analytics' },
];

if (!white_label_perkeso) {
  menuItems.push({ path: '/dashboard/whatsapp', icon: 'WhatsAppLogo', label: 'WhatsApp', isActiveCheck: (pathname) => pathname.startsWith('/dashboard/whatsapp') });
  menuItems.push({ path: '/dashboard/email-api-home', icon: 'EmailLogo', label: 'Email API' });
  menuItems.push({ path: '/dashboard/account/api-message', icon: 'DevelopersLogo', label: 'Developer' });
  menuItems.push({ path: 'https://help.elfo.com/', icon: 'HelpLogo', label: 'Help', external: true });
}

const SidebarItems = ({ sidebarShow }) => {
  const { pathname } = useLocation();

  const renderNavItem = useMemo(() => (item) => {
    const Icon = Icons[item.icon] || DefaultIcon;

    const isActive = !item.external && (item.isActiveCheck ? item.isActiveCheck(pathname) : pathname === item.path);
    const linkProps = item.external
      ? { as: 'a', href: item.path, target: '_blank', rel: 'noopener noreferrer' }
      : { as: Link, to: item.path };

    const content = (
      <>
        <span className="nav-icon">
          <Icon />
        </span>
        <span className="toggle-name">{item.label}</span>
      </>
    );

    const navLink = (
      <Nav.Link {...linkProps} active={isActive}>
        {content}
      </Nav.Link>
    );

    return (
      <Nav.Item as="li" key={item.path}>
        {sidebarShow ? (
          navLink
        ) : (
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id={`nav-${item.label.toLowerCase()}`}>{item.label}</Tooltip>}
          >
            {navLink}
          </OverlayTrigger>
        )}
      </Nav.Item>
    );
  }, [pathname, sidebarShow]);

  return (
    <Nav as="ul" className="responsive-scroll">
      {menuItems.map(renderNavItem)}
    </Nav>
  );
};

export default SidebarItems;
